import { withNamespaces } from "react-i18next";
import Accordion from 'react-bootstrap/Accordion';
import LegalEntitiesImage from "src/modules/3rd-party-management/assets/images/legal-entities.svg";
import { Table } from "reactstrap";
import {
    hasNonEmptyArray,
    parseHandelsregisterOrganizationData
} from "../../helpers";

const Network = ({
    t,
    activeAccordion,
    setActiveAccordion,
    detailsQuery
}) => {
    const data = parseHandelsregisterOrganizationData(detailsQuery?.data?.company);
    const connections = data?.network?.connections || [];

    if (!hasNonEmptyArray(connections)) {
        return null;
    }

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('network')}
            className={activeAccordion === 'network' ? 'active' : ''}
            eventKey={'network'}
        >
            <Accordion.Header>
                <img src={LegalEntitiesImage} alt="" />
                <span>{t('Relationship Network')}</span>
            </Accordion.Header>

            <Accordion.Body>
                <div className="table-responsive">
                    <Table bordered hover striped size="sm" className="mb-0">
                        <thead>
                            <tr>
                                <th>{t('Source')}</th>
                                <th>{t('Target')}</th>
                                <th>{t('Type')}</th>
                                <th>{t('Role')}</th>
                                <th>{t('From')}</th>
                                <th>{t('To')}</th>
                                <th>{t('Current')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {connections.map((conn, index) => (
                                <tr key={index}>
                                    <td>{conn.source?.name || '-'}</td>
                                    <td>{conn.target?.name || '-'}</td>
                                    <td>{conn.connection_type || conn.label || '-'}</td>
                                    <td>
                                        {conn.role?.en?.long ||
                                            conn.role?.de?.long ||
                                            conn.label ||
                                            '-'}
                                    </td>
                                    <td>{conn.start_date || '-'}</td>
                                    <td>{conn.end_date || '-'}</td>
                                    <td>{conn.is_current ? t('Yes') : t('No')}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </Accordion.Body>
        </Accordion.Item>
    );
};

export default withNamespaces()(Network);
